module.exports = __webpack_public_path__ + "static/media/400112_01.429f3ee5.png";